import React, {Component} from 'react';
import Spinner from './Spinner'
import Fab from '@material-ui/core/Fab';
import {fieldErrors, stripeErrors} from '../utils/errors'
import { graphql, navigate } from 'gatsby'
import { logEvent, pushToDataLayer } from './Analytics'

import {CardElement, CardNumberElement, CardExpiryElement, CardCVCElement, injectStripe} from 'react-stripe-elements';

class PaymentForm extends Component {
    constructor(props) {
        super(props);
        
        this.state = {
            loading: false,
            disabled: false
        }
    }

    async submit(ev) {
        const {email, terms, accountType, phone, errorMsg, cardName, referby, setCardNameError} = this.props;
        setCardNameError('')
        errorMsg('')
        if (!cardName.length) return setCardNameError(fieldErrors.nameOnCard)
        this.setState({loading: true, disabled: true});

        let {token, error} = await this.props.stripe.createToken({name: cardName});
        if(error){
            errorMsg(stripeErrors[error.code]);
            this.setState({loading: false, disabled: false});
            return false;
        }

        pushToDataLayer('addtocart_mixed', 'Cart', 'AddToCart', 'Mixed')

            const formState = {
                token: token,
                plan: accountType,
                name: cardName,
                email: email,
                phone: phone,
                location: "SE",
                campaign: 'common',
                trail: 30,
                coupon: 'true',
                referby,
                abTests: { experimentUpgradeDialog: 0 },
                origin: typeof window !== 'undefined' ? window.location.href : ''
            }

            fetch(`${process.env.API_URI}/users/create`, {
                method: 'POST',
                headers: {
                'Content-Type': 'application/json'
                },
                body: JSON.stringify(formState)
            })
            .then(resp => resp.json())
            .then(resp => {
                console.log('resp', resp)
                if (resp.status === 200) {

                    pushToDataLayer('addtocart_mixed', 'Purchase', 'done', 'Mixed');

                    navigate(
                        '/congrats',
                        { state: {email, plan: accountType, userId: resp.userId, campaign: 'common'} }
                    )
                } else {
                    errorMsg(resp.errorMsg);
                    this.setState({loading: false, disabled: false});
                }
            })
            .catch(error => console.error(error))
        
    }
    
    render() {
        const {disabled, loading} = this.state;
        const stripeStyle = {
            base: {
                fontSize: '16px',
                color: '#424770',
                letterSpacing: '0.025em',
                '::placeholder': {
                    color: '#aab7c4',
                },
            },
            invalid: {
                color: '#c23d4b'
            }
        };

        return (
            <div className="checkout">
                <div className='accountFormEmail'>
                    <h4>Kortnummer</h4>
                    <CardNumberElement className="form-control"
                        onChange={this.handleChange}
                        style={stripeStyle}
                    />
                </div>

                <div className='accountFormEmail'>
                    <h4>MM/YY</h4>
                    <CardExpiryElement  className="form-control w-50"
                        onChange={this.handleChange}
                        style={stripeStyle}
                        placeholder="MM/YY"
                    />
                </div>

                <div className='accountFormEmail'>
                    <h4>CVC</h4>
                    <CardCVCElement className="form-control w-50 last-w"
                        onChange={this.handleChange}
                        style={stripeStyle}
                        placeholder="XXX"
                    />
                </div>
                <label className="text-error">{this.props.errorText}</label>

                <Fab
                    variant="extended"
                    // size="small"
                    color="primary"
                    aria-label="Add"
                    className="registerButton"
                    disabled={disabled}
                    onClick={e => {
                            logEvent(
                                `Start page register payment button`,
                                `Start page register payment button was clicked`
                            );
                            this.submit();
                            pushToDataLayer(
								'userClick',
								'Start Page Register Payment Button',
								'Start Page Register Payment Button Was Clicked'
							)
                        }
                    }
                    
                    >
                    Påbörja din gratisperiod
                </Fab>
                {
                    loading && (
                        <Spinner size={48}/>
                    )
                }
            </div>
        );
    }
}

export default injectStripe(PaymentForm);